<script setup lang="ts">
import {computed} from "vue";
import ChatMessageStatus from "@/utils/constants/ChatMessageStatus.ts";

const props = defineProps<{
  status?: string;
}>();

const icon = computed(() => {
  switch (props.status) {
    case ChatMessageStatus.Read:
      return 'done_all';
    case ChatMessageStatus.Delivered:
    case ChatMessageStatus.Sent:
      return 'done';
    case ChatMessageStatus.Failed:
      return 'error_outline';
    default:
      return 'schedule';
  }
});

const colorClass = computed(() => {
  switch (props.status) {
    case ChatMessageStatus.Read:
      return 'tw-text-blue-400';
    case ChatMessageStatus.Failed:
      return 'tw-text-red-400';
    default:
      return 'tw-opacity-70';
  }
});
</script>

<template>
  <q-icon :name="icon" class="tw-text-[14px]" :class="colorClass"/>
</template>
